import * as React from 'react'
import { createPortal } from 'react-dom'

const ModalLayout = ({
  children,
  customZIndex = 9000,
}: {
  children: React.ReactNode
  customZIndex?: number
}) => {
  React.useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  const overlay = (
    <div
      className="modal-module tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-overflow-auto tw-overflow-y-auto tw-bg-content-base tw-bg-opacity-70"
      style={{ zIndex: customZIndex }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  )

  return createPortal(overlay, document.body)
}

export default ModalLayout
